export const AuthService = require('./AuthService');
export const OrderService = require('./OrderService');
export const LocationService = require('./LocationService'); 
export const CompanyService = require('./CompanyService');
export const FleetService = require('./FleetService');
export const ManifestService = require('./ManifestService');
export const UserService = require('./UserService');


// WEBPACK FOOTER //
// ./src/services/index.js